import { render, staticRenderFns } from "./UserAccessibilityModal.vue?vue&type=template&id=00725cb2&"
import script from "./UserAccessibilityModal.vue?vue&type=script&lang=js&"
export * from "./UserAccessibilityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports